import { z } from "zod"

export const currencySchema = z.enum(["NOK", "ZAR", "CAD", "EUR"])
export type Currency = z.infer<typeof currencySchema>

export const languageSchema = z.enum(["en-US", "no-NO", "fr-FR", "de-DE", "fi-FI", "da-DK"])
export type Languages = z.infer<typeof languageSchema>

export interface CommonFields {
  status?: "draft" | "published" | "archived"
  tenant?: string
}

// Basic schemas
export const idSchema = z.string()
export const dateSchema = z.date()

// Reusable schemas
export const auditFieldsSchema = z.object({
  date_created: dateSchema,
  date_updated: dateSchema.nullable(),
  user_created: idSchema,
  user_updated: idSchema.nullable(),
})

// Messages are the payment-plan contract's i18n keys (shared/src/contracts/
// paymentPlan.ts), localized by whoever reads the issue
// (localization/zodIssueMessage.ts) — the editor says the same thing
// whether the client or the server refused the row.
export const paymentPlanSchema = z.object({
  id: z.number(),
  description: z.string()
    .trim()
    .min(1, "contracts.paymentPlan.installmentDescriptionInvalid")
    .max(300, "contracts.paymentPlan.installmentDescriptionTooLong"),
  percentage: z.number()
    .min(0, "contracts.paymentPlan.installmentPercentageOutOfRange")
    .max(100, "contracts.paymentPlan.installmentPercentageOutOfRange"),
  accounting_order_id: z.string().nullable().optional(),
})
export type PaymentPlan = z.infer<typeof paymentPlanSchema>

export type ID<T extends { id: string }> = T["id"]
